module.exports = __webpack_public_path__ + "img/poll-info-background.07046a2b.png";